import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import posthog from 'posthog-js';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Features from './components/Features';
import PricingOverview from './components/PricingOverview';
import FoundingClinic from './components/FoundingClinic';
import Target from './components/Target';
import CTA from './components/CTA';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import DataProcessingAgreement from './components/DataProcessingAgreement';
import Pricing from './components/Pricing';

function PostHogPageView() {
  const location = useLocation();
  useEffect(() => {
    posthog.capture('$pageview', { $current_url: window.location.href });
  }, [location]);
  return null;
}

function HomePage() {
  return (
    <>
      <Hero />
      <Solutions />
      <Features />
      <PricingOverview />
      <FoundingClinic />
      <Target />
      <CTA />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <PostHogPageView />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/data-processing-agreement" element={<DataProcessingAgreement />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
